<template>
    <div class="expande-horizontal item-list wrap mb-2 mt-1 align-vertical">
        <v-flex xs12 md3>
            <div class="expande-horizontal align-vertical">
                <v-avatar small>
                    <h6 class="blue--text"> #{{ log.id }} </h6>
                </v-avatar>
                <v-divider vertical></v-divider>
                <v-list style="width: 100%;" color="transparent" three-line>
                    <v-list-item>
                        <v-icon class="mr-2" color="blue">account_circle</v-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle class="black--text">
                                {{log.funcionario.id}} - {{ log.funcionario.nome_abreviado }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                {{ $helper.formatDateTime(log.created_at) }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider vertical v-if="$vuetify.breakpoint.smAndUp"></v-divider>
            </div>
        </v-flex>
        <div class="expande-horizontal" style="border-bottom: 1px solid #e2e2e2" v-if="$vuetify.breakpoint.smAndDown"></div>
        <v-flex xs12 md5>
            <div class="expande-horizontal centraliza align-vertical" style="min-height: 60px;">
                <v-icon class="mr-2" size="9" color="blue">lens</v-icon>
                <span>
                    {{ log.descricao }}
                </span>
                            
            </div>
        </v-flex>
        <v-flex xs12 md4>
        <div class="expande-horizontal" style="border-bottom: 1px solid #e2e2e2" v-if="$vuetify.breakpoint.smAndDown"></div>
            <div :class="$vuetify.breakpoint.smAndUp ? 'bg-white' : ''" class="expande-horizontal">
                <v-divider vertical v-if="$vuetify.breakpoint.smAndUp"></v-divider>
                <v-list color="transparent" dense two-line>
                    <v-list-item>
                        <v-icon class="mr-3" size="18" color="blue">computer</v-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ log.ip }}
                            </v-list-item-title>
                            <v-list-item-subtitle style="font-size: 9pt;">
                                {{ log.hostname }}
                            </v-list-item-subtitle>
                            
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>
        </v-flex>
    </div>
</template>

<script>
export default {
    props: ['log']
}
</script>

<style>
    .align-vertical {
        align-items: center;
    }
    .wrap {
        flex-wrap: wrap;
    }
    .item-list {
        border: 1px solid #e2e2e2;
        border-radius: 12px;
        background: #f2f2f2;
    }
    .bg-white {
        background: white;
    }
</style>
